import React, { useEffect } from 'react';

import ReactPaginate from 'react-paginate';

export default function Pagination({ pageTotal, switchToPage, currentPage }) {
  useEffect(() => {
    const pageButtonsContainer = document.querySelectorAll(
      '.pagination-container li'
    );

    const firstPageButton = pageButtonsContainer[1];
    const lastPageButton =
      pageButtonsContainer[pageButtonsContainer.length - 2];

    if (firstPageButton) {
      if (pageButtonsContainer.length === 3) {
        firstPageButton.style.borderRadius = '0.25rem';
      } else {
        firstPageButton.style.borderRadius = '0.25rem 0 0 0.25rem';
      }
    }

    if (lastPageButton && pageButtonsContainer.length > 3) {
      lastPageButton.style.borderRadius = '0 0.25rem 0.25rem 0';
    }
  }, [pageTotal, currentPage]);

  return (
    <div>
      <div className="flex justify-center px-6 py-8">
        <ReactPaginate
          breakLabel="..."
          nextLabel={
            <svg className="h-4 w-4 fill-current" viewBox="0 0 16 16">
              <path d="M6.6 13.4L5.2 12l4-4-4-4 1.4-1.4L12 8z" />
            </svg>
          }
          pageLinkClassName="inline-flex justify-center items-center w-full h-full hover:bg-indigo-500 dark:hover:bg-indigo-500 hover:text-white"
          onPageChange={switchToPage}
          pageRangeDisplayed={5}
          pageCount={pageTotal}
          previousLabel={
            <svg className="h-4 w-4 fill-current" viewBox="0 0 16 16">
              <path d="M9.4 13.4l1.4-1.4-4-4 4-4-1.4-1.4L4 8z" />
            </svg>
          }
          nextLinkClassName="inline-flex w-full h-full justify-center items-center"
          disabledClassName="inline-flex items-center justify-center rounded leading-5 px-2.5 py-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-300 dark:text-slate-600 pointer-events-none"
          activeLinkClassName="text-indigo-500 pointer-events-none"
          containerClassName="inline-flex text-sm font-medium -space-x-px pagination-container"
          pageClassName="w-10 h-10 inline-flex items-center justify-center leading-5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 shadow-sm pageButton"
          breakClassName="inline-flex items-center justify-center leading-5 px-3.5 py-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-400 dark:text-slate-500"
          renderOnZeroPageCount={null}
          previousClassName="w-10 h-10 mr-2 inline-flex items-center justify-center rounded leading-5 bg-white dark:bg-slate-800 hover:bg-indigo-500 dark:hover:bg-indigo-500 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:text-white"
          nextClassName="w-10 h-10 inline-flex items-center justify-center rounded leading-5 bg-white dark:bg-slate-800 hover:bg-indigo-500 dark:hover:bg-indigo-500 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:text-white !ml-2"
        />
      </div>
    </div>
  );
}
